import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import QRClaim from '../components/QRClaim';
import BlacksmithWorkshop from '../components/BlacksmithWorkshop';
import { createGeneratorActor } from '../services/generator';
import { useAuth } from '../auth/useAuth';

export default function ClaimPage() {
  const { tokenId } = useParams<{ tokenId: string }>();
  const [nftData, setNftData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const { agent } = useAuth();

  useEffect(() => {
    const fetchNFT = async () => {
      if (!tokenId) return;
      if (!agent) return;
      
      try {
        // Fetch NFT data from generator canister
        const actor = await createGeneratorActor(agent);
        const nft = await actor.get_generated_nft(BigInt(tokenId));
        
        if (nft && nft.length > 0) {
          const nftData = nft[0];
          setNftData({
            token_id: Number(nftData.token_id),
            qr_code_data: nftData.qr_code_data,
            claimed: nftData.claimed,
            rarity_tier: nftData.rarity_tier,
          });
        } else {
          setNftData(null);
        }
      } catch (err) {
        console.error('Failed to fetch NFT:', err);
        setNftData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchNFT();
  }, [agent, tokenId]);

  if (loading) {
    return (
      <BlacksmithWorkshop>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-2xl text-gold">Loading...</div>
        </div>
      </BlacksmithWorkshop>
    );
  }

  if (!nftData) {
    return (
      <BlacksmithWorkshop>
        <div className="flex items-center justify-center min-h-screen">
          <div className="text-2xl text-red-400">NFT not found</div>
        </div>
      </BlacksmithWorkshop>
    );
  }

  return (
    <BlacksmithWorkshop>
      <div className="container mx-auto px-4 py-16">
        <QRClaim tokenId={nftData.token_id} qrData={nftData.qr_code_data} />
      </div>
    </BlacksmithWorkshop>
  );
}

